import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import {HomeComponent} from '../home/home.component';

declare var $ :any;
declare var System:any;

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {
  expanded:boolean=false;
  index:number=1;
  faqData:any[]=[];
  id:number=0;
  userTypeId:number=-1;
  planId:number=-1;
  isNext:boolean=false;
  constructor(private service:DataService,private home:HomeComponent ) { }

  ngOnInit() {
    $(window).scrollTop(0);
    this.listOfFAQ();

    this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
    this.planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"));
  }

  toggleExpanded(expanded,index){
   // console.log("index before "+index);
    this.index=index;
   // console.log("index after "+this.index);
    this.expanded=!expanded;
   // console.log(this.expanded);
    if(this.expanded==true && this.index==index){
      $('#collapse'+index).slideDown(200);
    }

    if(this.expanded==false && this.index==index) {
        $('#collapse'+index).slideUp(200);
    }

  }

  listOfFAQ(){
    this.service.ListOfFAQ()
    .subscribe(
      (result:any[])=>{
        if(result['Status']=="Success"){
          this.faqData=result['FAQDetailData'];
        } else {
          this.service.alert(result['Message'],"error");
        }
      },
      (error)=>{
       // console.log(error);
      }
    )
  }

  getFAQId(pvarId){
    this.id=pvarId;
    return "collapse"+this.id;
  }

  showActiveModule(pvarId){
    this.home.showActiveModule(pvarId);
  }


}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/faq/faq.component.ts